<template>
  <div class="auth-setup">
    <div class="card">
      <h1>🔧 Auth Setup</h1>
      <p class="subtitle">Select an auth version and apply the settings.</p>

      <div class="toggle-group">
        <button
          :class="['toggle-btn', selectedVersion === 'authv1' ? 'active' : '']"
          :disabled="done"
          @click="selectedVersion = 'authv1'"
        >
          authv1
        </button>
        <button
          :class="['toggle-btn', selectedVersion === 'authv2' ? 'active' : '']"
          :disabled="done"
          @click="selectedVersion = 'authv2'"
        >
          authv2
        </button>
      </div>

      <div class="status-list">
        <div :class="['status-item', statuses.config ? 'success' : 'pending']">
          <span class="icon">{{ statuses.config ? '✅' : '⏳' }}</span>
          <span>Clear <strong>config</strong> from localStorage</span>
        </div>
        <div :class="['status-item', statuses.auth ? 'success' : 'pending']">
          <span class="icon">{{ statuses.auth ? '✅' : '⏳' }}</span>
          <span
            >Set cookie <strong>authTester</strong> = <code>{{ selectedVersion }}</code></span
          >
        </div>
        <div :class="['status-item', statuses.fetchConfig ? 'success' : 'pending']">
          <span class="icon">{{ statuses.fetchConfig ? '✅' : '⏳' }}</span>
          <span>Fetch fresh config</span>
        </div>
      </div>

      <p
        v-if="error"
        class="error-msg"
      >
        {{ error }}
      </p>
      <p
        v-if="done"
        class="done-msg"
      >
        ✅ Done! Redirecting to sign in...
      </p>

      <button
        class="apply-btn"
        :disabled="done"
        @click="runSetup"
      >
        {{ done ? 'Done!' : 'Apply Settings' }}
      </button>
    </div>
  </div>
</template>

<script>
import configService from '@/services/config';

export default {
  name: 'AuthSetup',
  data() {
    return {
      selectedVersion: 'authv2',
      done: false,
      error: null,
      statuses: {
        config: false,
        auth: false,
        fetchConfig: false,
      },
    };
  },
  methods: {
    setCookie(name, value, days = 365) {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax; Secure`;
    },
    async runSetup() {
      this.error = null;

      // Clear config from localStorage using the service
      configService.clearConfig();
      this.statuses.config = true;

      // Set authTester cookie with selected version
      this.setCookie('authTester', this.selectedVersion);
      this.statuses.auth = true;

      // Fetch fresh config, then redirect to sign in
      try {
        await configService.getConfig();
        this.statuses.fetchConfig = true;
        this.done = true;
        this.$router.push('/signin');
      } catch (err) {
        this.error = `Failed to fetch config: ${err.message}`;
      }
    },
  },
};
</script>

<style scoped>
.auth-setup {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f4f6f9;
}
.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 420px;
  width: 100%;
  text-align: center;
}
h1 {
  font-size: 1.4rem;
  color: #1a1a2e;
  margin-bottom: 8px;
}
.subtitle {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 24px;
}
.toggle-group {
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #4f46e5;
  margin-bottom: 28px;
}
.toggle-btn {
  flex: 1;
  padding: 10px;
  background: #fff;
  color: #4f46e5;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;
}
.toggle-btn:first-child {
  border-right: 1px solid #4f46e5;
}
.toggle-btn.active {
  background: #4f46e5;
  color: #fff;
}
.toggle-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.status-list {
  text-align: left;
  margin-bottom: 28px;
}
.status-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 0.88rem;
  background: #f0f4ff;
  color: #555;
}
.status-item.success {
  background: #e6f9f0;
  color: #1a7a4a;
}
.apply-btn {
  width: 100%;
  padding: 13px;
  background: #4f46e5;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.apply-btn:hover:not(:disabled) {
  background: #4338ca;
}
.apply-btn:disabled {
  background: #a5b4fc;
  cursor: default;
}
.done-msg {
  margin-bottom: 16px;
  font-size: 0.85rem;
  color: #888;
}
.error-msg {
  margin-bottom: 16px;
  font-size: 0.85rem;
  color: #c0392b;
}
</style>
